import { makeStyles } from "@mui/styles";
import { COLORS } from "../../constant/colors";

const useStyles = makeStyles({
  profileSec: {
    paddingTop: "140px",
    "@media (max-width: 991px)": {
      paddingTop: "130px",
    },
    "@media (max-width: 500px)": {
      paddingTop: "100px",
    }
  },
  formSec: {
   width: "100%",
   textAlign: "center",
   padding: '0 15px'
  },
  heading: {
    margin: '60px 0 40px',
  },
  form: {
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
    padding: '35px 30px',
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto',
  },
  inputFeild: {
    padding: "12px 0 !important",
  },

  submit: {
    width: '100%',
    border: 'none',
    marginTop: 10,
    background: COLORS.primary,
    color: '#fff',
    padding: '10px 20px',
    borderRadius: 5,
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      background: COLORS.secondary,
    }
  },
  detailRow: {
    display: 'flex',
    paddingBottom: 20,
    borderBottom: '1px solid #e0e0e0',
    marginBottom: 20,
    alignItems: 'baseLine',
    width: '100%',
  },
  col: {
    marginLeft: 15,
    textAlign: 'left',
    display: 'flex',
    width: '80%',
  },
  label: {
    fontWeight: '500 !important',
    marginBottom: 0,
    marginTop: 2,
    marginRight: 15,
  },

  // New Profile Page Styles
  profileContainer: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 20px',
  },
  profileCard: {
    backgroundColor: COLORS.white,
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    marginBottom: '20px',
  },
  profileHeader: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    padding: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: COLORS.white,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '20px',
      textAlign: 'center',
    },
  },
  avatarSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  avatar: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    color: COLORS.white,
  },
  userInfo: {
    flex: 1,
  },
  userName: {
    fontSize: '24px',
    fontWeight: '600',
    margin: '0 0 8px 0',
    color: COLORS.white,
  },
  userEmail: {
    fontSize: '16px',
    opacity: 0.9,
    margin: 0,
    color: COLORS.white,
  },
  profileDetails: {
    padding: '30px',
  },
  detailCard: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  detailIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    backgroundColor: '#f8f9fa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    color: COLORS.primary,
    marginRight: '16px',
  },
  detailContent: {
    flex: 1,
  },
  detailLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#666',
    margin: '0 0 4px 0',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  detailValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: COLORS.textPrimary,
    margin: 0,
  },
  editButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
    paddingTop: '20px',
  },
  editButton: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    color: COLORS.white,
    border: 'none',
    padding: '12px 24px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(169, 37, 60, 0.3)',
    },
  },

  // Setup Profile Styles
  setupCard: {
    backgroundColor: COLORS.white,
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    maxWidth: '600px',
    margin: '0 auto',
  },
  setupHeader: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    padding: '40px 30px',
    textAlign: 'center',
    color: COLORS.white,
  },
  setupIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    color: COLORS.white,
    margin: '0 auto 20px',
  },
  setupTitle: {
    fontSize: '24px',
    fontWeight: '600',
    margin: '0 0 12px 0',
    color: COLORS.white,
  },
  setupDescription: {
    fontSize: '16px',
    opacity: 0.9,
    margin: 0,
    color: COLORS.white,
  },
  setupForm: {
    padding: '40px 30px',
  },
  formGroup: {
    marginBottom: '18px',
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      padding: '12px 16px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: COLORS.primary,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: COLORS.primary,
        borderWidth: '2px',
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: COLORS.primary,
    },
  },
  formActions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
  },
  submitButton: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    color: COLORS.white,
    border: 'none',
    padding: '12px 24px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '50%',
    justifyContent: 'center',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(169, 37, 60, 0.3)',
    },
  },

  // Update Profile Styles
  updateContainer: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '0 20px',
  },
  updateCard: {
    backgroundColor: COLORS.white,
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
  },
  updateHeader: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    padding: '30px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    color: COLORS.white,
  },
  updateIcon: {
    width: '60px',
    height: '60px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: COLORS.white,
  },
  updateInfo: {
    flex: 1,
  },
  updateTitle: {
    fontSize: '20px',
    fontWeight: '600',
    margin: '0 0 8px 0',
    color: COLORS.white,
  },
  updateDescription: {
    fontSize: '14px',
    opacity: 0.9,
    margin: 0,
    color: COLORS.white,
  },
  updateForm: {
    padding: '30px 20px',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    marginBottom: '20px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: '0',
    },
  },
  cancelButton: {
    background: '#f8f9fa',
    color: '#666',
    border: '2px solid #e9ecef',
    padding: '12px 24px',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '50%',
    justifyContent: 'center',
    '&:hover': {
      background: '#e9ecef',
      borderColor: '#dee2e6',
    },
  },
})

export default useStyles;